<template>
  <svg
    :class="{
      'stroke-black dark:stroke-white': !active,
      'stroke-lush-green': active,
      'duration-300': true
    }"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V4Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M4 8H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16 3V5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 3V5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup>
defineProps(['active'])
</script>

<style scoped></style>
